export const BUY_REQUEST_GETALL = "BUY_REQUEST_GETALL";

export const BUY_REQUEST_GETALL_ERROR = "BUY_REQUEST_GETALL_ERROR";

export const BUY_REQUEST_GETALL_PENDING = "BUY_REQUEST_GETALL_PENDING";

export const BUY_REQUEST_GETALL_SUCCESS = "BUY_REQUEST_GETALL_SUCCESS";

// export const TRANSACTION_TYPE_GETALL = "TRANSACTION_TYPE_GETALL";

// export const TRANSACTION_TYPE_GETALL_ERROR = "TRANSACTION_TYPE_GETALL_ERROR";

// export const TRANSACTION_TYPE_GETALL_PENDING =
//   "TRANSACTION_TYPE_GETALL_PENDING";

// export const TRANSACTION_TYPE_GETALL_SUCCESS =
//   "TRANSACTION_TYPE_GETALL_SUCCESS";

// export const CURRENCY_GET_ALL = "CURRENCY_GET_ALL";

// export const CURRENCY_GET_ALL_PENDING = "CURRENCY_GET_ALL_PENDING";

// export const CURRENCY_GET_ALL_ERROR = "CURRENCY_GET_ALL_ERROR";

// export const CURRENCY_GET_ALL_SUCCESS = "CURRENCY_GET_ALL_SUCCESS";

export const BUY_REQUEST_GET = "BUY_REQUEST_GET";

export const BUY_REQUEST_GET_SUCCESS = "BUY_REQUEST_GET_SUCCESS";

export const BUY_REQUEST_GET_ERROR = "BUY_REQUEST_GET_ERROR";

export const BUY_REQUEST_GET_PENDING = "BUY_REQUEST_GET_PENDING";

export const BUY_REQUEST_SAVE = "BUY_REQUEST_SAVE";

export const BUY_REQUEST_SAVE_PENDING = "BUY_REQUEST_SAVE_PENDING";

export const BUY_REQUEST_SAVE_SUCCESS = "BUY_REQUEST_SAVE_SUCCESS";

export const BUY_REQUEST_SAVE_ERROR = "BUY_REQUEST_SAVE_ERROR";

export const BUY_REQUEST_VIEW = "BUY_REQUEST_VIEW";

export const BUY_REQUEST_VIEW_PENDING = "BUY_REQUEST_VIEW_PENDING";

export const BUY_REQUEST_VIEW_SUCCESS = "BUY_REQUEST_VIEW_SUCCESS";

export const BUY_REQUEST_VIEW_ERROR = "BUY_REQUEST_VIEW_ERROR";

export const SAVE_ACCEPTED_LIST = "SAVE_ACCEPTED_LIST";

export const SAVE_ACCEPTED_LIST_ERROR = "SAVE_ACCEPTED_LIST_ERROR";

export const SAVE_ACCEPTED_LIST_SUCCESS = "SAVE_ACCEPTED_LIST_SUCCESS";

export const SAVE_ACCEPTED_LIST_PENDING = "SAVE_ACCEPTED_LIST_PENDING";

export const CANCEL_TRANSACTION = "CANCEL_TRANSACTION";

export const CANCEL_TRANSACTION_ERROR = "CANCEL_TRANSACTION_ERROR";

export const CANCEL_TRANSACTION_SUCCESS = "CANCEL_TRANSACTION_SUCCESS";

export const CANCEL_TRANSACTION_PENDING = "CANCEL_TRANSACTION_PENDING";

export const GET_ALL_SELL_REUQEST = "GET_ALL_SELL_REUQEST";

export const GET_ALL_SELL_REUQEST_PENDING = "GET_ALL_SELL_REUQEST_PENDING";

export const GET_ALL_SELL_REUQEST_SUCCESS = "GET_ALL_SELL_REUQEST_SUCCESS";

export const GET_ALL_SELL_REUQEST_ERROR = "GET_ALL_SELL_REUQEST_ERROR";

export const SALE_CONFIRMATION_SAVE = "SALE_CONFIRMATION_SAVE";

export const SALE_CONFIRMATION_SAVE_ERROR = "SALE_CONFIRMATION_SAVE_ERROR";

export const SALE_CONFIRMATION_SAVE_PENDING = "SALE_CONFIRMATION_SAVE_PENDING";

export const SALE_CONFIRMATION_SAVE_SUCCESS = "SALE_CONFIRMATION_SAVE_SUCCESS";

export const BUY_REQUEST_COMMODITYPRICES_GET =
  "BUY_REQUEST_COMMODITYPRICES_GET";

export const BUY_REQUEST_COMMODITYPRICES_GET_PENDING =
  "BUY_REQUEST_COMMODITYPRICES_GET_PENDING";

export const BUY_REQUEST_COMMODITYPRICES_GET_ERROR =
  "BUY_REQUEST_COMMODITYPRICES_GET_ERROR";

export const BUY_REQUEST_COMMODITYPRICES_GET_SUCCESS =
  "BUY_REQUEST_COMMODITYPRICES_GET_SUCCESS";

export const CANCEL_COMPLETED_TRANSACTION = "CANCEL_COMPLETED_TRANSACTION";
